import React, { Component } from 'react'
import _ from 'lodash'
import liffHelper from '../utils/liffHelper'
import utils from '../utils/utils'
import CeApi from '../lib/ce_api'

const liff = liffHelper.getLiff()

export default class LIFFWindow extends Component {
  constructor(props) {
    super(props)

    this.state = {
      init_success: false,
      login_channel_id: "",
      button_fetching: true
    }
  }

  openLIFFWindow(url) {
    liffHelper.openWindow(url, false);
  }

  openLIFFWindowExternal(url) {
    liffHelper.openWindow(url, true);
  }

  initSalesIQ (widgetCode) {
    var $zoho=$zoho || {};$zoho.salesiq = $zoho.salesiq || {widgetcode:widgetCode, values:{},ready:function(){}};
    window.$zoho = $zoho
    var d=document;
    var s=d.createElement("script");
    s.type="text/javascript";
    s.id="zsiqscript";
    s.defer=true;
    s.src="https://salesiq.zoho.com/widget";
    var t=d.getElementsByTagName("script")[0];
    //t.parentNode.insertBefore(s,t);
    document.body.appendChild(s);
    //d.write("<div id='zsiqwidget'></div>");
    var divEle = document.createElement('div');
    divEle.id = "zsiqwidget"
    document.body.append(divEle);
  }

  async componentDidMount() {
    var that = this
    try {
      let stateToBeSet = { init_success: true }

      let widgetCode = "7bc268dc7cf3471744a38121eef448734f30f7472b1ccfd7360951b981d026c868409cad85ff645e864c60b52c277087"

      that.initSalesIQ(widgetCode)

      let $zoho = window.$zoho
      $zoho.salesiq.ready=function() {
        $zoho.salesiq.visitor.name("測試名")
        $zoho.salesiq.visitor.email("test@mail.com")
        $zoho.salesiq.visitor.contactnumber("123456789")
        $zoho.salesiq.chatbutton.texts([["online時上排訊息1234", "online時下排訊息"], ["offline時上排訊息", "offline時上排訊息"]])
        //$zoho.salesiq.visitor.question("123124");
        //$zoho.salesiq.chat.start();
        that.setState({ "button_fetching": false })
      }

      await this.setState(stateToBeSet)
    } catch (e) {
      console.log(e)
      window.alert("聊天窗口連接失敗")
    }


    return
    // widget自動展開 dirty
    // let retryTimes = 0
    // let retryTimesLimit = 10
    // function clickZs() {
    //   try {
    //     retryTimes += 1
    //     var link = document.getElementById('zsiq_float')
    //     link.click()
    //   } catch (e) {
    //     if(retryTimes <= retryTimesLimit) retryClickWidget()
    //   }
    // }
    // function retryClickWidget() {
    //   setTimeout(clickZs,20)
    // }
    // retryClickWidget()
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevState.button_fetching !== this.state.button_fetching && this.state.button_fetching === false) {
      let $zoho = window.$zoho
      $zoho.salesiq.floatwindow.visible("show")
    }
  }

  render() {
    return (
      <React.Fragment>
        <header className="app-header">
          <h3 className="app-title">客服線上交談</h3>
        </header>
        <div className="page-content">
          <div className="container">
            <div className="row">

              <div className="col" />
              <div className="col-lg-6">
                <br />
                <br />
                <div className="jumbotron">
                  {
                    this.state.button_fetching
                    ?
                    <React.Fragment>
                      <p>客服聊天工具連線中</p>
                      <div className="spinner-border text-primary" style={{width: "6rem",  height: "6rem"}}  role="status" >
                        <span className="sr-only">Loading...</span>
                      </div>
                    </React.Fragment>
                    :
                    <React.Fragment>
                      <p>正在聯繫客服人員，請稍後</p>
                    </React.Fragment>
                  }
                </div>
              </div>
              <div className="col" />

            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/PureSalesIQ.js